<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  page: {
    title: "Cash Flow Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      current_date: moment(new Date()).format("YYYY-MM-DD"),
      filterIncome: {
        title: "",
        datefrom: "",
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        mode: "",
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      rep_total: {
        inc_total: "",
        exp_total: "",
      },
      fitered_array: [],
      title: "Cash Flow Report",
      items: [
        {
          text: "Account Section",
          href: "#/",
        },
        {
          text: "Cash Flow Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        // {
        //   key: "branch",
        //   sortable: true,
        //   label: "BRANCH",
        // },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },

        {
          key: "pay_mode",
          sortable: true,
          label: "PAYMENT MODE",
        },
        {
          key: "description",
          sortable: true,
          label: "NARATION",
        },
      ],
      //   ============================= EXPORT ==============================
      json_fields: {
        DATE: "date",
        BRANCH: "branch",
        AMOUNT: "amount",
        PAYMENT_MODE: "pay_mode",
        NARATION: "description",
        // TOTAL_INCOME: "total_inc",
        // TOTAL_EXPENDITURE: "total_exp",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    // MAP STATE
    ...mapState("reports", ["income"]),
    ...mapGetters("reports", ["Income"]),
    ...mapGetters("payments", ["PaymentModes"]),

    rows() {
      return this.fitered_array ? this.fitered_array.length : 1;
    },
  },
  watch: {
    income(newValue) {
      if (newValue.length > 0) {
        this.setincomeData();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Income ? this.Income.length : 1;
  },
  methods: {
    ...mapActions({
      FetchIncome: "reports/fetchIncome",
      FetchPaymentModes: "payments/fetchPaymentModes",
    }),

    setincomeData() {
      this.fitered_array = this.Income;
      let total_income = 0;
      this.fitered_array.forEach((value) => {       
          let total1 = value.amount;
          let total2 = total1.replace(",", "");
          let total = parseInt(total2);
          total_income = total_income + total;
      });
      this.rep_total.inc_total = this.thousandSeprator(total_income);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    localizeDate(date) {
      if (!date || !date.includes("-")) return date;
      const [yyyy, mm, dd] = date.split("-");
      return new Date(`${mm}/${dd}/${yyyy}`);
    },
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    filter_report() {
      let startDate = this.localizeDate(this.filterIncome.datefrom);
      let endDate = this.localizeDate(this.filterIncome.dateto);
      let total_income = 0;
      if (startDate != "" && endDate != "" && this.filterIncome.mode == "") {
        this.filterIncome.title =
          "INCOME REPORT FROM <b class='text-primary'>" +
          this.filterIncome.datefrom +
          " </b> TO <b class='text-primary'>" +
          this.filterIncome.dateto +
          "</b>";
        this.fitered_array = this.Income.filter((pymts) => {
          if (
            this.localizeDate(pymts.filter_date) >= startDate &&
            this.localizeDate(pymts.filter_date) <= endDate
          ) {           
              let total1 = pymts.amount;
              let total2 = total1.replaceAll(",", "");
              let total = parseInt(total2);
              total_income = parseInt(total_income) + total;
          }
          return (
            this.localizeDate(pymts.filter_date) >= startDate &&
            this.localizeDate(pymts.filter_date) <= endDate
          );
        });
      } else if (startDate != "" && endDate != "" && this.filterIncome.mode != "") {
        this.fitered_array = this.Income.filter((pymts) => {
          if (
            this.localizeDate(pymts.filter_date) >= startDate &&
            this.localizeDate(pymts.filter_date) <= endDate &&
            pymts.mode_id == this.filterIncome.mode
          ) {
            this.filterIncome.title =
              "INCOME REPORT FROM <b class='text-primary'>" +
              this.filterIncome.datefrom +
              " </b> TO <b class='text-primary'>" +
              this.filterIncome.dateto +
              "</b> FOR <b class='text-primary'>" +
              pymts.pay_mode +
              "</b>";
              let total1 = pymts.amount;
              let total2 = total1.replaceAll(",", "");
              let total = parseInt(total2);
              total_income = parseInt(total_income) + total;
          }
          return (
            this.localizeDate(pymts.filter_date) >= startDate &&
            this.localizeDate(pymts.filter_date) <= endDate &&
            pymts.mode_id == this.filterIncome.mode
          );
        });
      } else if (startDate == "" && endDate != "" && this.filterIncome.mode != "") {
        this.fitered_array = this.Income.filter((pymts) => {
          if (
            this.localizeDate(pymts.filter_date) <= endDate &&
            pymts.mode_id == this.filterIncome.mode
          ) {
            this.filterIncome.title =
              "INCOME REPORT </b> FOR <b class='text-primary'>" +
              pymts.pay_mode +
              "</b>";            
              let total1 = pymts.amount;
              let total2 = total1.replaceAll(",", "");
              let total = parseInt(total2);
              total_income = parseInt(total_income) + total;
          }
          return (
            this.localizeDate(pymts.filter_date) <= endDate &&
            pymts.mode_id == this.filterIncome.mode
          );
        });
      } else {
        this.fitered_array = this.Income;
      }

      this.rep_total.inc_total = this.thousandSeprator(total_income);
    },
  },
  created() {
    this.setincomeData();
    this.FetchIncome();
    this.FetchPaymentModes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title mb-2 text-center" v-html="filterIncome.title"></h3>
            <div class="row">
              <div class="col-md-4 form-group">
                <label>FROM</label>
                <input
                  @change="filter_report()"
                  type="date"
                  v-model="filterIncome.datefrom"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
                  @change="filter_report()"
                  v-model="filterIncome.dateto"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>PAYMENT MODE</label>
                <model-list-select
                  @input="filter_report()"
                  :list="PaymentModes ? PaymentModes : []"
                  v-model="filterIncome.mode"
                  option-value="id"
                  option-text="mode"
                  placeholder="select pyment mode"
                  required
                >
                </model-list-select>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
              <download-excel
                  class="btn btn-primary mb-1"
                  :data="fitered_array"
                  :fields="json_fields"
                  :worksheet="'INCOME REPORT FOR' + current_date"
                  type="csv"
                  :name="'Income_report' + current_date + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
                <div id="tickets-table_length" class="dataTables_length mt-2">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                foot-clone
                class="datatables"
                :items="fitered_array ? fitered_array : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(actions)="data">
                  <button @clinc="yes(data)" class="btn btn-primary btn-sm">
                    Details
                  </button>
                </template>               
                <template #foot(pay_mode)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(date)="">
                  <span class="text-danger"></span>
                </template>                
                <template #foot(branch)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(description)="">
                  <span class="text-danger"></span>
                </template>
                <template #foot(amount)="">
                  <span class="text-danger"></span>
                </template>                
              </b-table>
              <div class="text-center text-bold">
                  <b>Total Income: 
                  <span class="text-primary"> {{ rep_total.inc_total }}</span></b>
                </div>
              <center>
                <h3 v-if="!Income" class="text-primary">
                  <b-spinner class="m-0" letiant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
